import BotContainer from './components/BotContainer';
import './App.css';
import { useEffect, useState } from 'react';

const App = () => {
  const queryParam = new URLSearchParams(window.location.search);
  const dialogId = queryParam.get('dialog_id') || '';

  let paramsObj: any = {};
  queryParam.forEach((value, key) => {
    paramsObj[key] = value;
  });

  const regex =
    /Mobile|Android|iP(hone|od|ad)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Fennec|Opera Mini|Opera Mobi/i;
  const isMobile = regex.test(navigator.userAgent);

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <BotContainer
      dialogId={dialogId}
      isMobile={isMobile}
      collapsed={width <= height}
      params={paramsObj}
    />
  );
};

export default App;
